export default "__VITE_ASSET__BUJBq0m$__"